export const fieldsetTrigger = {
  getTitleElement() {
    if (!this._titleElement) {
      this._titleElement = this._element.querySelector(`.filter-title`);
    }

    return this._titleElement;
  },

  getButtonElement() {
    if (!this._buttonElement) {
      this._buttonElement = this._element.querySelector(`.filter-fieldset__button`);
    }

    return this._buttonElement;
  },

  getFieldsetContent() {
    if (!this._fieldsetContent) {
      this._fieldsetContent = this._element.querySelector(`.filter-fieldset-content`);
    }

    return this._fieldsetContent;
  },

  hideFieldsetContent() {
    this.getFieldsetContent().style.display = `none`;
  },

  resetFieldsetContent() {
    this.getFieldsetContent().style.display = null;
  },

  activate() {
    const button = this.getButtonElement();
    button.classList.add(`${button.classList[0]}_active`);
  },

  deactivate() {
    const button = this.getButtonElement();
    button.classList.remove(`${button.classList[0]}_active`);
  },

  activateTitle() {
    this.getTitleElement().classList.add(`${this.getTitleElement().classList[0]}_active`);
  },

  deactivateTitle() {
    this.getTitleElement().classList.remove(`${this.getTitleElement().classList[0]}_active`);
  },

  setButtonClickHandler(callback) {
    this._callback.buttonClick = callback;
    this.getButtonElement().addEventListener(`click`, this._buttonClickHandler.bind(this));
  },

  _buttonClickHandler() {
    this._callback.buttonClick();
  }
};

fieldsetTrigger._fieldsetContent = fieldsetTrigger._fieldsetContent;
fieldsetTrigger._buttonElement = fieldsetTrigger._buttonElement;
fieldsetTrigger._titleElement = fieldsetTrigger._titleElement;
fieldsetTrigger._callback = fieldsetTrigger._callback;
